export interface LoginState {
  email: string
  password: string
  onFail: {
    message: string
    attempts: number
  }
}

export const initialState = {
  email: '',
  password: '',
  onFail: {
    message: '',
    attempts: 0,
  },
}

export const login = (
  state: LoginState = initialState,
  action: ReduxAction,
): LoginState => {
  switch (action.type) {
    case 'UPDATE_LOGIN_EMAIL':
      return {
        ...state,
        email: action.payload,
      }
    case 'UPDATE_LOGIN_PASSWORD':
      return {
        ...state,
        password: action.payload,
      }
    case 'RESET_LOGIN_ATTEMPT_FAIL':
      return {
        ...state,
        onFail: {
          message: '',
          attempts: 0,
        },
      }
    case 'ON_LOGIN_ATTEMPT_FAIL':
      return {
        ...state,
        onFail: {
          message: action.payload,
          attempts: state.onFail.attempts + 1,
        },
      }
    default:
      return state
  }
}
